/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NgxFullpageSectionDirective as Éµc} from './lib/basic/ngx-fullpage-section.directive';
export {NgxFullpageWrapperDirective as Éµb} from './lib/basic/ngx-fullpage-wrapper.directive';
export {NgxFullpageGoToLastDirective as Éµa} from './lib/just-fullpage-go-to-last/ngx-fullpage-go-to-last.directive';
export {NgxFullpageGoToSectionDirective as Éµg} from './lib/just-fullpage-go-to-section/ngx-fullpage-go-to-section.directive';
export {NgxFullpageNextButtonDirective as Éµd} from './lib/next-button/ngx-fullpage-next-button.directive';
export {NgxFullpagePrevButtonDirective as Éµe} from './lib/next-button/ngx-fullpage-prev-button.directive';
export {NgxFullpageToFirstButtonDirective as Éµf} from './lib/top-button/ngx-fullpage-to-first-button.directive';